@if (sidebarService.isOpen()) {
  <div class="sidebar-backdrop" (click)="sidebarService.close()"></div>
  <aside #sidebarElement class="sidebar-panel" role="dialog" tabindex="-1" [attr.aria-label]="panelTitle()">
    <div class="sidebar-panel__header">
      @if (sidebarService.canGoBack()) {
        <button
          type="button"
          class="sidebar-panel__back"
          aria-label="Go back"
          (click)="sidebarService.back()"
        >
          ←
        </button>
      }
      <span class="sidebar-panel__title">{{ panelTitle() }}</span>
      <button
        type="button"
        class="sidebar-panel__close"
        aria-label="Close sidebar"
        (click)="sidebarService.close()"
      >
        ×
      </button>
    </div>
    <div class="sidebar-panel__body">
      @switch (sidebarService.currentPanel()?.type) {
        @case (SidebarPanelType.NotificationList) {
          <app-notification-list-panel />
        }
        @case (SidebarPanelType.NotificationDetail) {
          <app-notification-detail-panel />
        }
        @case (SidebarPanelType.SearchResults) {
          <app-search-results-panel />
        }
        @case (SidebarPanelType.SalesOrderDetail) {
          <app-sales-order-detail-panel />
        }
        @case (SidebarPanelType.CprDetail) {
          <app-cpr-detail-panel />
        }
        @case (SidebarPanelType.InvoiceDetail) {
          <app-invoice-detail-panel />
        }
      }
    </div>
  </aside>
}
